var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: {
        id: "recipe",
        itemscope: "",
        itemtype: "http://schema.org/Recipe"
      }
    },
    [
      _c(
        "section",
        { staticClass: "full-width no-y-padding", attrs: { id: "hero" } },
        [
          _c("div", { class: _vm.container_class }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _vm.show_image && _vm.recipe.recipe_post_top_image
                    ? _c("img", {
                        staticClass: "nopin",
                        attrs: {
                          itemprop: "image",
                          src: _vm.recipe.recipe_post_top_image,
                          alt: _vm.recipe.page_title
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.show_back
                    ? _c(
                        "div",
                        {
                          staticClass: "back",
                          attrs: { onclick: "window.history.back();" }
                        },
                        [_c("i", { staticClass: "fas fa-arrow-left" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.logged_in
                    ? _c("FavouriteWidget", {
                        attrs: { logged_in: _vm.logged_in, post: _vm.recipe },
                        on: {
                          "update:post": function($event) {
                            _vm.recipe = $event
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.logged_in
                    ? _c("PlannerWidget", {
                        attrs: { logged_in: _vm.logged_in }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "full-width", attrs: { id: "recipe-intro" } },
        [
          _c("div", { class: _vm.container_class }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h1", { attrs: { itemprop: "name" } }, [
                  _vm._v(_vm._s(_vm.recipe.page_title))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12" }, [
                _vm.icons.length
                  ? _c(
                      "div",
                      { attrs: { id: "recipe-icons" } },
                      _vm._l(_vm.icons, function(icon, index) {
                        return _c("img", {
                          key: index,
                          attrs: { src: icon, alt: "" }
                        })
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "key-info" }, [
                  _c("div", { staticClass: "timing-wrapper" }, [
                    _vm.recipe.recipe_post_top_cook_time
                      ? _c("div", [
                          _vm._v("Cook\n\t\t\t\t\t\t\t\t\t"),
                          _c("meta", { attrs: { itemprop: "cookTime" } }),
                          _vm._v(
                            " " + _vm._s(_vm.recipe.recipe_post_top_cook_time)
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.recipe.recipe_post_top_prep_time
                      ? _c("div", [
                          _vm._v("Prep\n\t\t\t\t\t\t\t\t\t"),
                          _c("meta", { attrs: { itemprop: "prepTime" } }),
                          _vm._v(
                            " " + _vm._s(_vm.recipe.recipe_post_top_prep_time)
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "people-input-wrapper" }, [
                    _c("div", { staticClass: "label" }, [_vm._v("Serves")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "people-button vue-btn",
                        on: { click: _vm.decrementPeople }
                      },
                      [_c("i", { staticClass: "fas fa-caret-left" })]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.people,
                          expression: "people",
                          modifiers: { number: true }
                        }
                      ],
                      attrs: { id: "people", readonly: "" },
                      domProps: { value: _vm.people },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.people = _vm._n($event.target.value)
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "people-button vue-btn",
                        on: {
                          click: function($event) {
                            _vm.people++
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-caret-right" })]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "button-wrapper" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm.enable_goals
                    ? _c(
                        "button",
                        {
                          staticClass: "core-btn",
                          class: {
                            "goal-complete": _vm.marked_as_complete,
                            thinking: _vm.goal_thinking
                          },
                          attrs: {
                            id: "mark-goal-complete",
                            disabled: _vm.marked_as_complete
                          },
                          on: { click: _vm.mark_recipe_goal_complete }
                        },
                        [
                          _c("i", { staticClass: "far fa-check-square" }),
                          _vm._v(
                            " " + _vm._s(_vm.mark_goal_complete_button_text)
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "core-btn core-btn-secondary",
                      attrs: { id: "print" },
                      on: { click: _vm.print }
                    },
                    [_c("i", { staticClass: "far fa-print" }), _vm._v("Print")]
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "full-width no-padding-top", attrs: { id: "main" } },
        [
          _c("div", { class: _vm.container_class }, [
            (_vm.recipe.recipe_post_main_ingredients &&
              _vm.recipe.recipe_post_main_ingredients.length) ||
            (_vm.recipe.recipe_ingredients_v2 &&
              _vm.recipe.recipe_ingredients_v2.length)
              ? _c("div", { staticClass: "row" }, [
                  _vm.recipe.recipe_post_main_ingredients &&
                  _vm.recipe.recipe_post_main_ingredients.length &&
                  !_vm.recipe.recipe_ingredients_v2
                    ? _c("div", { staticClass: "col-12 col-md-6" }, [
                        _c("h3", [_vm._v("Ingredients")]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(
                            _vm.recipe.recipe_post_main_ingredients,
                            function(item, index) {
                              return _c(
                                "li",
                                {
                                  key: index,
                                  attrs: { itemprop: "recipeIngredient" }
                                },
                                [_vm._v(_vm._s(item.content))]
                              )
                            }
                          ),
                          0
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.recipe.recipe_ingredients_v2 &&
                  _vm.recipe.recipe_ingredients_v2.length
                    ? _c("div", { staticClass: "col-12 col-md-6" }, [
                        _c("h3", [_vm._v("Ingredients")]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(_vm.recipe.recipe_ingredients_v2, function(
                            item,
                            index
                          ) {
                            return _c(
                              "li",
                              {
                                key: index,
                                attrs: { itemprop: "recipeIngredient" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_amount(
                                      item.amount,
                                      item.unit.label,
                                      _vm.people,
                                      _vm.serves
                                    )["amount"]
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.get_amount(
                                        item.amount,
                                        item.unit.label,
                                        _vm.people,
                                        _vm.serves
                                      )["unit"]
                                    ) +
                                    " " +
                                    _vm._s(item.ingredient)
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-12 col-md-6",
                      attrs: { itemprop: "recipeInstructions" }
                    },
                    [
                      _c("h3", [_vm._v("Method")]),
                      _vm._v(" "),
                      _c(
                        "ol",
                        _vm._l(_vm.recipe.recipe_post_instructions, function(
                          item,
                          index
                        ) {
                          return _c("li", { key: index }, [
                            _vm._v(_vm._s(item.content))
                          ])
                        }),
                        0
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.logged_in
              ? _c("div", { staticClass: "row", attrs: { id: "notes" } }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", [_vm._v("Notes")]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(_vm.recipe.recipe_post_main_text)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(_vm.recipe.recipe_post_notice)
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { attrs: { id: "user-notes" } }, [
                  _c("h3", [_vm._v("Your notes")]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user_note,
                        expression: "user_note"
                      }
                    ],
                    attrs: { id: "user-note" },
                    domProps: { value: _vm.user_note },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.user_note = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "core-btn vue-btn",
                      on: { click: _vm.save_note }
                    },
                    [_c("i", { staticClass: "far fa-save" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "core-btn vue-btn",
                      on: { click: _vm.delete_note }
                    },
                    [_c("i", { staticClass: "far fa-trash-alt" })]
                  )
                ])
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "core-btn", attrs: { id: "whisk-add-to-basket" } },
      [
        _c("i", { staticClass: "far fa-shopping-cart" }),
        _vm._v("Add to shopping list")
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }